import React from 'react';
import { useI18n } from 'react-simple-i18n';

export default function ErrorView() {
	const { t } = useI18n();

	return <div>{t('viewError.title')}</div>;
}
